import { operationInProgress, updateUser } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import SessionStorage from '../../util/sessionstore'
import { message } from 'antd'
import { fetchInProgress, serviceError } from './patient.action'

const session = new SessionStorage()

/*
Actions to be dispatched for signin
- Update Signature
    Get patient information for given company
- service error
*/

export function companyFetchInProgress(isLoading) {
  return {
    type: ActionType.COMPANY_INPROGRESS,
    isLoading,
  }
}

export function companyList({ companies, pagination, searchText }) {
  return {
    type: ActionType.COMPANY_LIST,
    companies,
    pagination,
    searchText,
    isLoading: false,
  }
}

export function fetchCompanies(params) {
  return async (dispatch) => {
    try {
      dispatch(companyFetchInProgress(true))
      var data = await serviceInterface.CompanyService().getCompanies(params)
      dispatch(companyFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        data.pagination.total = data.total
        dispatch(companyList(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(companyFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addEditCompany(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.CompanyService().addEditCompany(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchCompany(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.CompanyService().getCompany(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addEditSupportProfile(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .CompanyService()
        .addEditSupportProfile(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteSupportProfile(companyid, id) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .CompanyService()
        .deleteSupportProfile(companyid, id)
      dispatch(fetchInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
